import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Impede quantidade mínima de parcelas maior que a máxima. Ignorado quando o parcelamento está
 * desligado (os controles de parcelas ficam desabilitados).
 */
export const parcelasCoerentesValidator: ValidatorFn = (
  group: AbstractControl,
): ValidationErrors | null => {
  const minimas = group.get('parcelasMinimas');
  const maximas = group.get('parcelasMaximas');
  if (!minimas || !maximas || minimas.disabled || maximas.disabled) {
    return null;
  }
  const min = Number(minimas.value);
  const max = Number(maximas.value);
  if (!Number.isFinite(min) || !Number.isFinite(max)) {
    return null;
  }
  return min > max ? { parcelasIncoerentes: true } : null;
};

/**
 * Impede fim de vigência anterior ao início. Fim em branco é vigência sem data de término.
 * As datas são ISO (`yyyy-MM-dd`), então a comparação textual equivale à cronológica.
 */
export const vigenciaCoerenteValidator: ValidatorFn = (
  group: AbstractControl,
): ValidationErrors | null => {
  const inicio = group.get('inicio')?.value as string | undefined;
  const fim = group.get('fim')?.value as string | undefined;
  if (!inicio || !fim) {
    return null;
  }
  return fim < inicio ? { vigenciaIncoerente: true } : null;
};

/** Exige pelo menos um regime de tributação marcado (IR regressivo, IR progressivo ou os dois). */
export const regimeTributacaoObrigatorioValidator: ValidatorFn = (
  group: AbstractControl,
): ValidationErrors | null => {
  const regressivo = group.get('irRegressivo')?.value;
  const progressivo = group.get('irProgressivo')?.value;
  return regressivo || progressivo ? null : { regimeTributacaoObrigatorio: true };
};

/** Exige valor maior que zero quando preenchido; campo vazio é aceito. */
export const valorPositivoValidator: ValidatorFn = (
  control: AbstractControl,
): ValidationErrors | null => {
  const valor = control.value;
  if (valor === null || valor === undefined || valor === '') {
    return null;
  }
  return Number(valor) > 0 ? null : { valorPositivo: true };
};

/** Impede valor mínimo da retenção maior que o máximo. Valores iguais são aceitos. */
export const retencaoCoerenteValidator: ValidatorFn = (
  group: AbstractControl,
): ValidationErrors | null => {
  const minimo = group.get('valorMinimo')?.value;
  const maximo = group.get('valorMaximo')?.value;
  if (minimo === null || minimo === '' || maximo === null || maximo === '') {
    return null;
  }
  const min = Number(minimo);
  const max = Number(maximo);
  if (!Number.isFinite(min) || !Number.isFinite(max)) {
    return null;
  }
  return min > max ? { retencaoIncoerente: true } : null;
};
